// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_breakout_room.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_breakout_room.proto.
 */
export const file_plugnmeet_breakout_room: GenFile = /*@__PURE__*/
  fileDesc("Ch1wbHVnbm1lZXRfYnJlYWtvdXRfcm9vbS5wcm90bxIJcGx1Z25tZWV0IqwBChZDcmVhdGVCcmVha291dFJvb21zUmVxEg8KB3Jvb21faWQYASABKAkSGQoRcmVxdWVzdGVkX3VzZXJfaWQYAiABKAkSFAoIZHVyYXRpb24YAyABKARCAjABEhgKC3dlbGNvbWVfbXNnGAQgASgJSACIAQESJgoFcm9vbXMYBSADKAsyFy5wbHVnbm1lZXQuQnJlYWtvdXRSb29tQg4KDF93ZWxjb21lX21zZyKRAQoMQnJlYWtvdXRSb29tEgoKAmlkGAEgASgJEg0KBXRpdGxlGAIgASgJEhQKCGR1cmF0aW9uGAMgASgEQgIwARIPCgdzdGFydGVkGAQgASgIEhMKB2NyZWF0ZWQYBSABKARCAjABEioKBXVzZXJzGAYgAygLMhsucGx1Z25tZWV0LkJyZWFrb3V0Um9vbVVzZXIiPAoQQnJlYWtvdXRSb29tVXNlchIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEg4KBmpvaW5lZBgDIAEoCCJiCh9JbmNyZWFzZUJyZWFrb3V0Um9vbUR1cmF0aW9uUmVxEhgKEGJyZWFrb3V0X3Jvb21faWQYASABKAkSFAoIZHVyYXRpb24YAiABKARCAjABEg8KB3Jvb21faWQYAyABKAkiOwobQnJvYWRjYXN0QnJlYWtvdXRSb29tTXNnUmVxEgsKA21zZxgBIAEoCRIPCgdyb29tX2lkGAMgASgJImMKE0pvaW5CcmVha291dFJvb21SZXESGAoQYnJlYWtvdXRfcm9vbV9pZBgBIAEoCRIPCgd1c2VyX2lkGAIgASgJEg8KB3Jvb21faWQYAyABKAkSEAoIaXNfYWRtaW4YBCABKAgiPwoSRW5kQnJlYWtvdXRSb29tUmVxEhgKEGJyZWFrb3V0X3Jvb21faWQYASABKAkSDwoHcm9vbV9pZBgDIAEoCSKpAQoPQnJlYWtvdXRSb29tUmVzEg4KBnN0YXR1cxgBIAEoCBILCgNtc2cYAiABKAkSEgoFdG9rZW4YAyABKAlIAIgBARIqCgRyb29tGAQgASgLMhcucGx1Z25tZWV0LkJyZWFrb3V0Um9vbUgBiAEBEiYKBXJvb21zGAUgAygLMhcucGx1Z25tZWV0LkJyZWFrb3V0Um9vbUIICgZfdG9rZW5CBwoFX3Jvb21CowEKDWNvbS5wbHVnbm1lZXRCGlBsdWdubWVldEJyZWFrb3V0Um9vbVByb3RvUAFaMmdpdGh1Yi5jb20vbXluYXBhcnJvdC9wbHVnbm1lZXQtcHJvdG9jb2wvcGx1Z25tZWV0ogIDUFhYqgIJUGx1Z25tZWV0ygIJUGx1Z25tZWV04gIVUGx1Z25tZWV0XEdQQk1ldGFkYXRh6gIJUGx1Z25tZWV0YgZwcm90bzM");

/**
 * @generated from message plugnmeet.CreateBreakoutRoomsReq
 */
export type CreateBreakoutRoomsReq = Message<"plugnmeet.CreateBreakoutRoomsReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string requested_user_id = 2;
   */
  requestedUserId: string;

  /**
   * @generated from field: uint64 duration = 3 [jstype = JS_STRING];
   */
  duration: string;

  /**
   * @generated from field: optional string welcome_msg = 4;
   */
  welcomeMsg?: string | undefined;

  /**
   * @generated from field: repeated plugnmeet.BreakoutRoom rooms = 5;
   */
  rooms: BreakoutRoom[];
};

/**
 * Describes the message plugnmeet.CreateBreakoutRoomsReq.
 * Use `create(CreateBreakoutRoomsReqSchema)` to create a new message.
 */
export const CreateBreakoutRoomsReqSchema: GenMessage<CreateBreakoutRoomsReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_breakout_room, 0);

/**
 * @generated from message plugnmeet.BreakoutRoom
 */
export type BreakoutRoom = Message<"plugnmeet.BreakoutRoom"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: uint64 duration = 3 [jstype = JS_STRING];
   */
  duration: string;

  /**
   * @generated from field: bool started = 4;
   */
  started: boolean;

  /**
   * @generated from field: uint64 created = 5 [jstype = JS_STRING];
   */
  created: string;

  /**
   * @generated from field: repeated plugnmeet.BreakoutRoomUser users = 6;
   */
  users: BreakoutRoomUser[];
};

/**
 * Describes the message plugnmeet.BreakoutRoom.
 * Use `create(BreakoutRoomSchema)` to create a new message.
 */
export const BreakoutRoomSchema: GenMessage<BreakoutRoom> = /*@__PURE__*/
  messageDesc(file_plugnmeet_breakout_room, 1);

/**
 * @generated from message plugnmeet.BreakoutRoomUser
 */
export type BreakoutRoomUser = Message<"plugnmeet.BreakoutRoomUser"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool joined = 3;
   */
  joined: boolean;
};

/**
 * Describes the message plugnmeet.BreakoutRoomUser.
 * Use `create(BreakoutRoomUserSchema)` to create a new message.
 */
export const BreakoutRoomUserSchema: GenMessage<BreakoutRoomUser> = /*@__PURE__*/
  messageDesc(file_plugnmeet_breakout_room, 2);

/**
 * @generated from message plugnmeet.IncreaseBreakoutRoomDurationReq
 */
export type IncreaseBreakoutRoomDurationReq = Message<"plugnmeet.IncreaseBreakoutRoomDurationReq"> & {
  /**
   * @generated from field: string breakout_room_id = 1;
   */
  breakoutRoomId: string;

  /**
   * @generated from field: uint64 duration = 2 [jstype = JS_STRING];
   */
  duration: string;

  /**
   * @generated from field: string room_id = 3;
   */
  roomId: string;
};

/**
 * Describes the message plugnmeet.IncreaseBreakoutRoomDurationReq.
 * Use `create(IncreaseBreakoutRoomDurationReqSchema)` to create a new message.
 */
export const IncreaseBreakoutRoomDurationReqSchema: GenMessage<IncreaseBreakoutRoomDurationReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_breakout_room, 3);

/**
 * @generated from message plugnmeet.BroadcastBreakoutRoomMsgReq
 */
export type BroadcastBreakoutRoomMsgReq = Message<"plugnmeet.BroadcastBreakoutRoomMsgReq"> & {
  /**
   * @generated from field: string msg = 1;
   */
  msg: string;

  /**
   * @generated from field: string room_id = 3;
   */
  roomId: string;
};

/**
 * Describes the message plugnmeet.BroadcastBreakoutRoomMsgReq.
 * Use `create(BroadcastBreakoutRoomMsgReqSchema)` to create a new message.
 */
export const BroadcastBreakoutRoomMsgReqSchema: GenMessage<BroadcastBreakoutRoomMsgReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_breakout_room, 4);

/**
 * @generated from message plugnmeet.JoinBreakoutRoomReq
 */
export type JoinBreakoutRoomReq = Message<"plugnmeet.JoinBreakoutRoomReq"> & {
  /**
   * @generated from field: string breakout_room_id = 1;
   */
  breakoutRoomId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string room_id = 3;
   */
  roomId: string;

  /**
   * @generated from field: bool is_admin = 4;
   */
  isAdmin: boolean;
};

/**
 * Describes the message plugnmeet.JoinBreakoutRoomReq.
 * Use `create(JoinBreakoutRoomReqSchema)` to create a new message.
 */
export const JoinBreakoutRoomReqSchema: GenMessage<JoinBreakoutRoomReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_breakout_room, 5);

/**
 * @generated from message plugnmeet.EndBreakoutRoomReq
 */
export type EndBreakoutRoomReq = Message<"plugnmeet.EndBreakoutRoomReq"> & {
  /**
   * @generated from field: string breakout_room_id = 1;
   */
  breakoutRoomId: string;

  /**
   * @generated from field: string room_id = 3;
   */
  roomId: string;
};

/**
 * Describes the message plugnmeet.EndBreakoutRoomReq.
 * Use `create(EndBreakoutRoomReqSchema)` to create a new message.
 */
export const EndBreakoutRoomReqSchema: GenMessage<EndBreakoutRoomReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_breakout_room, 6);

/**
 * @generated from message plugnmeet.BreakoutRoomRes
 */
export type BreakoutRoomRes = Message<"plugnmeet.BreakoutRoomRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * join token
   *
   * @generated from field: optional string token = 3;
   */
  token?: string | undefined;

  /**
   * for my breakout room
   *
   * @generated from field: optional plugnmeet.BreakoutRoom room = 4;
   */
  room?: BreakoutRoom | undefined;

  /**
   * rooms list
   *
   * @generated from field: repeated plugnmeet.BreakoutRoom rooms = 5;
   */
  rooms: BreakoutRoom[];
};

/**
 * Describes the message plugnmeet.BreakoutRoomRes.
 * Use `create(BreakoutRoomResSchema)` to create a new message.
 */
export const BreakoutRoomResSchema: GenMessage<BreakoutRoomRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_breakout_room, 7);

